import React from 'react';
import { Reveal } from './Reveal';

const STEPS = [
  {
    n: '01',
    badge: 'bg-bw-primary',
    title: 'Discover',
    body: 'BidWin reads SAM.gov and surfaces the few opportunities that fit your NAICS codes, set-aside status, and capabilities — leading with the best fits closing soonest.',
  },
  {
    n: '02',
    badge: 'bg-bw-primary',
    title: 'Qualify',
    body: 'A verdict-first score tells you whether a bid is worth your time — and why. Run the AI deep-score on the ones that earn it, then decide with justified confidence.',
  },
  {
    n: '03',
    badge: 'bg-bw-accent',
    title: 'Write',
    body: 'Generate a proposal draft where every claim arrives with its evidence chip attached. Gaps are flagged, never papered over — so what you submit, you can defend.',
  },
];

/** Section 04 — the three-stage workflow. */
export function WorkflowSection() {
  return (
    <section id="workflow" className="max-w-[1180px] mx-auto px-5 sm:px-8 py-24 scroll-mt-20">
      <Reveal className="max-w-[640px] mb-[54px]">
        <div className="font-mono text-[11px] font-semibold tracking-[0.14em] text-bw-accent mb-4">
          04 — HOW IT WORKS
        </div>
        <h2 className="text-[clamp(30px,3.6vw,46px)] leading-[1.08] font-extrabold tracking-[-0.03em] text-bw-sidebar">
          Discover. Qualify. Write.
        </h2>
      </Reveal>

      <Reveal>
        <div className="flex flex-wrap gap-6">
          {STEPS.map((s) => (
            <div
              key={s.n}
              className="flex-1 basis-[300px] min-w-[260px] bg-bw-surface border border-bw-border rounded-[14px] p-8 shadow-card"
            >
              <div
                className={`font-mono text-[13px] font-semibold text-white ${s.badge} w-[34px] h-[34px] rounded-[9px] flex items-center justify-center mb-5`}
              >
                {s.n}
              </div>
              <h3 className="text-[21px] font-bold tracking-tight mb-2.5 text-bw-ink">{s.title}</h3>
              <p className="text-[15px] leading-[1.55] text-bw-muted">{s.body}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
